import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const CVCfour = (props: Props) => {
  const { disabled, register } = props;

  const info = [
    '經由鎖骨下靜脈或內頸靜脈插管時，可能發生併發症，包括：鎖骨下動脈穿刺、臂叢神經損傷、氣胸、血胸、空氣栓塞、鄰近血管穿孔出血、心包填塞、心房穿孔、心律不整與儀器相關問題等。若經股靜脈插入，則可能發生股動脈穿刺、鼠蹊或腹膜後出血等併發症。',
    '插管後可能產生感染、導管內血栓形成，以及插管部位血管血栓或狹窄。',
    '需於穿刺部位及皮膚切口處放置止血沙袋 2 小時，期間應盡量避免變換體位。',
    '插管處可能出現瘀青或腫脹，數日內會自然緩解。',
    '插管或使用過程中可能發生氣胸、血胸、積液或空氣栓塞等併發症。',
    '若使用過程中導管位置偏移或阻塞，應立即確認；若發生感染，須拔除導管。',
    '為預防感染需進行敷料包紮，並定期注入無菌生理食鹽水以防止導管阻塞。',
  ];

  return (
    <Fragment>
      <SectionTitle title="4. 術後注意事項" />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map((a, i) => {
            return (
              <Grid item xs={11.5}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: '30px',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCfour;
